import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout'
import DriverDocuments from './DriverDocuments';
import messages from '../../../locale/messages';
import { restrictUrls } from '../../../helpers/adminPrivileges';

function action({ store, params, intl }) {

    const title = "Driver Documents";

    // From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().adminPrevileges.privileges && store.getState().adminPrevileges.privileges.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/login' }
    }

    // Admin restriction
    if (!restrictUrls('/siteadmin/drivers', adminPrivileges)) {
        return { redirect: '/siteadmin' };
    }

    const driverId = params.id;
    return {
        title,
        component: (
            <AdminLayout>
                <DriverDocuments title={title} driverId={driverId} />
            </AdminLayout>
        )
    }
}

export default action;